import {
    FETCH_CREDIT_USAGE_SUCCESS,
    FETCH_CREDIT_USAGE_FAILURE,
    DOWNLOAD_CREDIT_USAGE_SUCCESS,
    DOWNLOAD_CREDIT_USAGE_FAILURE,
    FETCH_CREDIT_USAGE_GRAPH_TILE_SUCCESS,
    FETCH_CREDIT_USAGE_GRAPH_TILE_FAILURE,
    FETCH_PRODUCT_NAME_SUCCESS,
    FETCH_PRODUCT_NAME_FAILURE
} from './action'

const initialState = {
    fetchCreditUsageDataSuccess: null,
    fetchCreditUsageDataFailure: null,
    downloadCreditUsageData: [],
    downloadCreditUsageDataFailure: null,
    fetchCreditUsageGraphDataSuccess: null,
    fetchCreditUsageGraphDataFailure: null,
    fetchProductNameSuccess: [],
    fetchProductNameFailure: null
}

const ceditUsageReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CREDIT_USAGE_SUCCESS:
            return state = {
                ...state,
                fetchCreditUsageDataSuccess: action.data
            }
        case FETCH_CREDIT_USAGE_FAILURE:
            return state = {
                ...state,
                fetchCreditUsageDataFailure: action.data
            }
        case FETCH_PRODUCT_NAME_SUCCESS:
            return state = {
                ...state,
                fetchProductNameSuccess: action.data
            }
        case FETCH_PRODUCT_NAME_FAILURE:
            return state = {
                ...state,
                fetchProductNameSuccess: []
            }
        case DOWNLOAD_CREDIT_USAGE_SUCCESS:
            return state = {
                ...state,
                downloadCreditUsageData: action.data
            }
        case DOWNLOAD_CREDIT_USAGE_FAILURE:
            return state = {
                ...state,
                downloadCreditUsageDataFailure: action.data
            }
        case FETCH_CREDIT_USAGE_GRAPH_TILE_SUCCESS:
            return state = {
                ...state,
                fetchCreditUsageGraphDataSuccess: action.data
            }
        case FETCH_CREDIT_USAGE_GRAPH_TILE_FAILURE:
            return state = {
                ...state,
                fetchCreditUsageGraphDataFailure: action.data
            }
        default:
            return state
    }
}

export default ceditUsageReducer;